import React from 'react';
import { ChevronLeft, Close } from '@material-ui/icons';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useStyles } from './styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { useSelector } from 'react-redux';
import { getSelectedComponentWithOptions } from '../../Reducers/App/Selectors';
import { ComponentSelectorHeaderProps } from './ComponentsHeader';

interface ComponentsHeaderProps extends ComponentSelectorHeaderProps {
  onBackClick: () => void;
}
// Header when a component selected
const OptionsHeader: React.FC<ComponentsHeaderProps> = (props) => {
  const classes = useStyles();
  const selectedComponent = useSelector(getSelectedComponentWithOptions);
  const { onBackClick, onCloseClick } = props;

  const handleBack = () => {
    onBackClick();
  };

  const handleClose = () => {
    onCloseClick();
  };

  return (
    <>
      <div className={classes.row}>
        <div className={classes.back} onClick={handleBack}>
          <ChevronLeft />
          <Typography>{t('back')}</Typography>
        </div>
        <Close className={classes.toggle} onClick={handleClose} />
      </div>
      <div className={clsx(classes.row, classes.optionsHeader)}>
        <Typography>{selectedComponent.title}</Typography>
      </div>
    </>
  );
};

export default OptionsHeader;
